import utils from './utils';

class Query {
    constructor() {
        this.oVal= utils.parseQuery(window.location.search.substr(1)) || {}
    }

    get value() {
        return this.oVal;
    }
}

export default new Query();


// WEBPACK FOOTER //
// ./src/common/js/query.js